import { mapState } from 'pinia'
import camelCase from 'lodash/camelCase'
import { useRootStore } from '~/store/root'

export default {
  computed: {
    ...mapState(useRootStore, ['userProfile']),
    isEmbeddedUser() {
      return Boolean(this.userProfile && this.userProfile.isEmbedded)
    }
  },
  methods: {
    logUserEvent ({ action, data = {} }) {
      if (this.isEmbeddedUser) {
        window.parent.postMessage({
          source: 'BP',
          method: 'postUserEvent',
          action: camelCase(action),
          data: JSON.parse(JSON.stringify(data))
        }, '*')
      }
    }
  }
}
